import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** shadcn/ui class helper: conditional classes with Tailwind conflict resolution. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Firestore timestamps arrive as {seconds} or as a Date; render both, plus the "not yet" case. */
export function formatDateTime(value: unknown): string {
  const date = toDate(value)
  if (!date) return '—'
  return new Intl.DateTimeFormat('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date)
}

export function toDate(value: unknown): Date | null {
  if (!value) return null
  if (value instanceof Date) return value
  if (typeof value === 'number') return new Date(value)
  if (typeof value === 'object' && 'toDate' in value && typeof value.toDate === 'function') {
    return (value as { toDate: () => Date }).toDate()
  }
  return null
}

/**
 * Cleans a translations map before saving: trims values and drops blank ones, so a stored map only
 * ever holds meaningful overrides. The port of `sanitizedTranslations()` in the app.
 */
export function sanitizeTranslations(values: Record<string, string>): Record<string, string> {
  const result: Record<string, string> = {}
  for (const [tag, value] of Object.entries(values)) {
    const trimmed = value.trim()
    if (trimmed.length > 0) result[tag] = trimmed
  }
  return result
}
